import store from '@/packages/vuex'

export default {
	install (Vue) {
		Vue.prototype.$can = (value, departmentId) => {
			if (departmentId) {
				return store.getters['Auth/user'].permissionForDepartment(
					value,
					departmentId
				)
			}
			return store.getters['Auth/user'].hasPermission(value)
		}
		Vue.prototype.$may = (value, departmentId) => {
			if (departmentId) {
				return store.getters['Auth/user'].permissionForDepartment(
					value,
					departmentId
				)
			}
			return store.getters['Auth/user'].hasSomePermission(value)
		}
		Vue.prototype.$auth = () => store.getters['Auth/user']
		Vue.prototype.$app = () => ({
			configuration: () => store.getters['App/configuration'],
			updateConfiguration: config =>
				store.commit('App/UPDATE_CONFIGURATION', config)
		})
	}
}
